// @flow strict
import { Divider, message } from 'antd';
import React, { useState } from 'react';
import { updateReferRule } from '../../../../api/refer';
import FormComponent from '../../../../component/common/FormComponent';

function UpdateRedeemRule({ setUpdateModal, rule, setReferRules }) {
  const [loading, setLoading] = useState(false);

  const defaultValues = {
    points: rule?.points,
    days: rule?.days,
    token: rule?.token,
    assistant: rule?.assistant,
    advance_parameter: rule?.advance_parameter,
    customize_chat: rule?.customize_chat,
    chat_providers: rule?.chat_providers,
    max_file: rule?.max_file,
    user: rule?.user,
  };

  const handleUpdateData = async (values) => {

    try {
      const res = await updateReferRule(rule?._id, values);
      if (res?.data?.status === "success") {
        message.success(res.data?.message);
        setUpdateModal(false);
        setReferRules((prev) => {
          const temp = JSON.parse(JSON.stringify(prev));
          const index = temp.findIndex((item) => item?._id === rule?._id);
          temp[index] = res.data?.referRule;
          return temp;
        });
      };
    } catch (error) {
      message.error(error?.message);
    } finally {
      setLoading(false);
    };
  };

  const formItems = [
    {
      name: "points",
      label: "Redeem Points (It will be cost)",
      placeholder: "How many points will be cost for this rule?",
      type: "number",
      rules: [
        {
          required: true,
          message: "Redeem Points is required!",
        },
      ],
    },
    {
      name: "days",
      label: "Extend Expiry Days (It will be added with the current cycle)",
      placeholder: "How many days will be added to the current cycle?",
      type: "number",
    },
    {
      name: "token",
      label: "Chat Token",
      placeholder: "How many tokens will be added to the current cycle?",
      type: "number",
      rules: [
        {
          required: true,
          message: "Chat token is required!",
        },
      ],
    },
    {
      name: "assistant",
      label: "Assistant Limit",
      placeholder: "How many assistant will be added to the current cycle?",
      type: "number",
    },
    {
      name: "chat_providers",
      label: "Chat Providers",
      placeholder: "Select chat providers",
      type: "multiselect",
      options: ['openai', 'gemini', 'claude'].map((item) => ({
        label: item,
        value: item,
      })),
    },
    {
      name: "max_file",
      label: "Max File Upload",
      placeholder: "Maximum file upload limit.",
      type: "number",
    },
    {
      name: "user",
      label: "User Limit",
      placeholder: "How many user will be added to the current cycle?",
      type: "number",
    },
    {
      name: "advance_parameter",
      label: "Access to Advance Parameter Settings",
      type: "checkbox",
    },
    {
      name: "customize_chat",
      label: "Access to Customize Chat.",
      type: "checkbox",
    },
    {
      name: "submitreset",
      submitlabel: "Update Rule",
      resetlabel: "Reset",
      type: "submitreset",
      className: "m-1",
      loading: loading
    },
  ];

  return (
    <>
      <Divider />
      <FormComponent
        formItems={formItems}
        handleSubmit={handleUpdateData}
        layout="vertical"
        className="form"
        defaultValues={defaultValues}
      />
    </>
  );
};

export default UpdateRedeemRule;